import { useEffect, useState } from "react";
import { StatsChart } from "../../components/admin/Dashboard/StatsChart";
import { StatCards } from "../../components/admin/Dashboard/StatCards";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { getAdminStats } from "../../redux/slices/admin.slices/stats.slice";
import { timeRanges } from "../../constants/admin/dashboardConstants";
import { useTranslation } from "react-i18next";

export function AdminDashboard() {
  const dispatch = useDispatch();
  const { selectedCity } = useSelector((state: RootState) => state.city);
  const stats = useSelector((state: RootState) => state?.stats);
  const { t } = useTranslation();
  const [timeRange, setTimeRange] = useState("30");

  useEffect(() => {
    if (timeRange && selectedCity?.city) {
      dispatch(
        getAdminStats({
          timeRange,
          city:
            selectedCity?.city === "All cities"
              ? selectedCity?._id
              : selectedCity?.city,
        }) as any
      );
    }
  }, [timeRange, selectedCity, dispatch]);

  return (
    <div className="animate-fade-in-up p-6">
      <h1 className="text-2xl font-bold mb-6">{t("Dashboard")}</h1>

      <div className="flex flex-wrap gap-4 mb-6">
        <select
          value={timeRange}
          onChange={(e) => setTimeRange(e.target.value)}
          className="px-3 py-2 rounded-lg shadow bg-popupLight dark:bg-popupDark dark:text-primaryTextDark text-primaryText"
        >
          {timeRanges.map((timeRange) => (
            <option key={timeRange.value} value={timeRange.value}>
              {t(timeRange.label)}
            </option>
          ))}
        </select>
      </div>
      <StatCards stats={stats} />
      <StatsChart yearlyRevenue={stats?.yearlyRevenue} />
    </div>
  );
}
